import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './dropdown-style.css';

const Dropdown = (props, ref) => {
  const { menu, toggle, placement, className, onOpen, bodyScrollDisabled, closeBtnValue } = props;
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  const initBtnClose = closeBtnValue && closeBtnValue.length;

  function toggleOpen() {
    if (open === false && onOpen) {
      onOpen();
    }

    setOpen(!open);
  }

  function closeMenu() {
    setTimeout(() => {
      setOpen(false);
    }, 20);
  }

  useImperativeHandle(ref, () => ({
    close: () => {
      closeMenu();
    },
  }));

  useEffect(() => {
    if (open) {
      const closeItems = menuRef.current.getElementsByClassName('close-menu');
      Object.keys(closeItems).map((key) => {
        closeItems[key].addEventListener('click', closeMenu);
        return true;
      });

      if (bodyScrollDisabled) {
        document.body.style.overflow = 'hidden';
      }
    } else {
      if (bodyScrollDisabled) {
        document.body.style.overflow = 'auto';
      }
    }
  }, [open]);

  return (
    <div className="dropdown">
      <div className="dropdown-toggle" onClick={toggleOpen}>
        {toggle}
      </div>
      {open && <div className="dropdown-closer" onClick={closeMenu} />}
      {open && (
        <div className={`animation ${className ? className : ''}`}>
          <div className={`f-row w-100 dropdown-menu ${placement} ${initBtnClose ? 'btns' : ''}`} ref={menuRef}>
            {menu}
            {initBtnClose && (
              <div className="dropdown-close d-flex align-items-center justify-content-center" onClick={closeMenu}>
                <span>{closeBtnValue}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default forwardRef(Dropdown);
